import { forwardRef, Ref } from 'react';
import { Fab, type KindKeys } from './styled';

interface Props {
  kind?: KindKeys;
  active?: boolean;
  withMargin?: boolean;
  onClick?: () => void;
  children?: JSX.Element;
  style?: object;
  type?: 'submit' | 'reset' | 'button';
  iconSize?: number | string;
  disabled?: boolean;
}

const ActionIconButton = forwardRef((props: Props, ref: Ref<HTMLButtonElement>) => {
  const {
    kind = 'basic',
    active = false,
    withMargin = false,
    children,
    onClick = () => null,
    iconSize = '34px',
    ...rest
  } = props;

  return (
    <Fab
      ref={ref}
      onClick={onClick}
      kind={kind}
      active={active}
      withMargin={withMargin}
      iconSize={iconSize}
      disableRipple
      {...rest}
    >
      {children}
    </Fab>
  );
});

export { ActionIconButton };
